<template>
  <div>
    <modal id="id-proofing-imgpreview" v-model="modal" :append-to-body="true" size="max">
      <h4 slot="title" class="smalltitle">Preview File</h4>
      <div class="body">
        <iframe class="emr-pdf-preview img-preview" scrolling="auto"
                :src="file.link"></iframe>
      </div>
      <div slot="footer">
        <div class="row">
          <div class="col-xs-6 text-left">
            <span v-if="file && file.type == 'cell_phone_bill'">Phone: <b>{{formatPhone(file.phone)}}</b></span>
            <span v-if="file && file.type != 'cell_phone_bill'">
              License Number: {{ file.type_number ? file.type_number : 'N/A' }} - Expiration: {{ file.expiration_date ? formatTime(file.expiration_date) : 'N/A' }} - State:{{ file.state ? file.state : 'N/A' }} {{file.phone ? (' - Phone: ' + formatPhone(file.phone)) : ' - Phone: N/A'}}
            </span>
          </div>
          <div class="col-xs-6 text-right">
            <button class="btn btn-default btn-sm"
                    style="margin-right: 5px"
                    v-if="needToAcceptDeny || (!showButtonUpdateStatus(file) && Number(file.status) !== 1)"
                    @click.prevent="changeStatusFile(file, 1)">
              <!--<i class="fas fa-spinner fa-spin" v-if="processingStatus"></i>-->
              ACCEPT
            </button>

            <button class=" btn btn-default btn-sm"
                    v-if="needToAcceptDeny || (!showButtonUpdateStatus(file) && Number(file.status) !== 2)"
                    @click.prevent="changeStatusFile(file, 2)">
              <!--<i class="fas fa-spinner fa-spin" v-if="processingStatus"></i>-->
              DENY
            </button>

            <button type="button" class="btn btn-default" @click.prevent="modal = false">Close
            </button>
          </div>
        </div>
      </div>
    </modal>
    <modal id="id-proofing-modal" class="skintestblock" v-model="dataDeny.modalDeny" :append-to-body="true"
           :backdrop="false">
      <h4 slot="title" class="smalltitle">Deny file</h4>
      <div class="prolabel">Reason</div>
      <div class="profield"><input type="text" v-model="dataDeny.reasonCancel" autofocus></div>

      <div slot="footer">
        <button type="button" class="btn btn-default" @click.prevent="confirmDenyFile">
          <i class="fas fa-spinner fa-spin" v-if="processingStatus"></i> Deny
        </button>
        <button type="button" class="btn btn-default" @click.prevent="dataDeny.modalDeny = false">Close
        </button>
      </div>
    </modal>
  </div>

</template>

<script>
import Common from '../../../components/mixins/Common'
import { mapGetters } from 'vuex'
import httpClient from '@/client'

export default {
  name: 'PreviewPdf',
  mixins: [Common],
  props: {
    file: {
      required: true
    },
    needToAcceptDeny: {
      default: false
    },
    typeFile: {
      default: null
    }
  },
  data () {
    return {
      modal: false,
      dataDeny: {
        reasonCancel: '',
        modalDeny: false,
        file: null
      },
      processingStatus: false
    }
  },
  created () {
  },
  computed: {
    ...mapGetters({
      storeLocations: 'locations',
      storeStaffs: 'staffs',
      storeSelectedLocation: 'selectedLocation',
      storeSelectedStaff: 'selectedStaff',
      storeLocationObject: 'locationObject'
    })
  },
  destroyed () {
  },
  mounted () {
    this.modal = true
    console.log('this.file', this.file)
  },
  watch: {
    modal (newVal, oldVal) {
      this.$emit('updateModal', newVal)
    }
  },
  methods: {
    confirmDenyFile () {
      this.updateStatus(this.dataDeny.file, 2)
    },
    async changeStatusFile (file, statusUpdate) {
      if (statusUpdate === 2) {
        this.dataDeny.reasonCancel = ''
        this.dataDeny.modalDeny = true
        this.dataDeny.file = file
        return
      }
      this.updateStatus(file, statusUpdate)
    },
    async updateStatus (file, statusUpdate) {
      if (this.processingStatus) {
        return
      }
      if (this.typeFile == 'CREDENTIAL') {
        this.$emit('updateStatus', { file, statusUpdate, reasonCancel: this.dataDeny.reasonCancel })
        return
      }
      try {
        let data = {
          id: file.id,
          status: statusUpdate,
          reasonCancel: this.dataDeny.reasonCancel
        }
        this.processingStatus = true
        let response = await httpClient.put(`/users/doctor/update-status-id-proof`, data)
        this.processingStatus = false
        if (response.data.s === 200) {
          file.status = response.data.data.status
          file.statusText = response.data.data.statusText
          this.dataDeny.modalDeny = false
          this.$forceUpdate()
        } else {
          this.alertError(response.data.msg)
        }
      } catch (e) {
        this.processingStatus = false
        this.alertError('Server error when update status ')
      }
    },
    showButtonUpdateStatus (file) {
      return Number(file.status) !== 0 || file.deleted_at || file.kind === 'credit_card'
    }

  }

}
</script>
<style>
#id-proofing-modal {
  z-index: 999999999999999 !important;
}
</style>
<style scoped>
 #id-proofing-imgpreview {
     z-index: 99999999999999 !important;
 }
</style>
